export default __webpack_public_path__ + "static/media/R.acb5124c.png";